import { useEffect, useState } from 'react';

export const nativePurchasesAvailable = (host = window) => host.__ODYSSEY_NATIVE_PURCHASES__ === 1
  && typeof host.ReactNativeWebView?.postMessage === 'function';

export function useNativePurchases() {
  const [available, setAvailable] = useState(() => nativePurchasesAvailable());
  useEffect(() => {
    const update = () => setAvailable(nativePurchasesAvailable());
    window.addEventListener('odyssey:purchase-capability', update);
    update();
    return () => window.removeEventListener('odyssey:purchase-capability', update);
  }, []);
  return { available, open: () => {
    if (nativePurchasesAvailable()) window.ReactNativeWebView.postMessage(JSON.stringify({ type: 'OPEN_PLANNING_CREDITS', version: 1 }));
  } };
}
